const getSubscribedVehicle = state => state.subscribedVehicle;
const getMediaDialog = state => state.mediaDialog;
const getEventDialog = state => state.eventDialog;

export default {
    getSubscribedVehicle,
    getMediaDialog,
    getEventDialog
};
